import React, { useState, useEffect } from 'react'
import { serbaUsahaService } from '../../services/serbaUsahaService'
import { memberService } from '../../services/memberService'

function TransaksiBaru() {
  const [barang, setBarang] = useState([])
  const [cart, setCart] = useState([])
  const [jenis, setJenis] = useState('Tunai')
  const [nba, setNba] = useState('')
  const [nama, setNama] = useState('')
  const [anggota, setAnggota] = useState(null)
  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    serbaUsahaService.getBarang({ limit: 200 }).then(res => setBarang(res.data.data || []))
  }, [])

  const formatCurrency = (val) => new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0)

  const addToCart = (item) => {
    const existing = cart.find(c => c.KodeBarang === item.KodeBarang)
    if (existing) {
      setCart(cart.map(c => c.KodeBarang === item.KodeBarang ? { ...c, Qty: c.Qty + 1 } : c))
    } else {
      setCart([...cart, { KodeBarang: item.KodeBarang, NamaBarang: item.NamaBarang, HargaTunai: item.HargaTunai, HargaKredit: item.HargaKredit, Qty: 1 }])
    }
  }

  const removeFromCart = (kode) => setCart(cart.filter(c => c.KodeBarang !== kode))
  const updateQty = (kode, qty) => {
    if (qty <= 0) { removeFromCart(kode); return }
    setCart(cart.map(c => c.KodeBarang === kode ? { ...c, Qty: parseInt(qty) } : c))
  }

  const totalHarga = cart.reduce((sum, c) => {
    const harga = jenis === 'Kredit' ? parseFloat(c.HargaKredit) : parseFloat(c.HargaTunai)
    return sum + harga * c.Qty
  }, 0)

  const handleCariAnggota = async () => {
    if (!nba) return
    try {
      const res = await memberService.getById(nba)
      setAnggota(res.data.data)
    } catch { setAnggota(null); alert('Anggota tidak ditemukan') }
  }

  const handleSubmit = async () => {
    if (cart.length === 0) return alert('Belum ada item')
    if (jenis === 'Kredit' && !anggota) return alert('Cari anggota dulu untuk kredit')
    setSubmitting(true)
    try {
      const res = await serbaUsahaService.createTransaksi({
        NBA: anggota?.NBA || null,
        Nama: jenis === 'Tunai' ? nama : undefined,
        TglTransaksi: new Date().toISOString().slice(0, 10),
        JenisTransaksi: jenis,
        Items: cart.map(c => ({ KodeBarang: c.KodeBarang, Qty: c.Qty }))
      })
      alert(`Transaksi berhasil! No: ${res.data.data.NoTransaksi}`)
      setCart([]); setAnggota(null); setNba(''); setNama('')
    } catch (err) { alert('Gagal: ' + (err.response?.data?.message || err.message)) }
    finally { setSubmitting(false) }
  }

  return (
    <div className="card">
      <div className="card-header"><h3 className="card-title">Transaksi Baru</h3></div>
      <div className="card-body">
        <div className="row mb-3">
          <div className="col-md-4">
            <label>Jenis Transaksi</label>
            <select className="form-control" value={jenis} onChange={e => setJenis(e.target.value)}>
              <option value="Tunai">Tunai</option>
              <option value="Kredit">Kredit</option>
            </select>
          </div>
          {jenis === 'Tunai' ? (
            <div className="col-md-4">
              <label>Nama Pembeli (opsional)</label>
              <input className="form-control" value={nama} onChange={e => setNama(e.target.value)} placeholder="Non-anggota" />
            </div>
          ) : (
            <div className="col-md-5">
              <label>Cari Anggota (NBA)</label>
              <div className="input-group">
                <input className="form-control" value={nba} onChange={e => setNba(e.target.value)} placeholder="Masukkan NBA" />
                <div className="input-group-append">
                  <button className="btn btn-info" onClick={handleCariAnggota}><i className="fas fa-search"></i></button>
                </div>
              </div>
              {anggota && <small className="text-success">{anggota.Nama} ({anggota.NBA})</small>}
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-md-5">
            <h6>Pilih Barang</h6>
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              {barang.filter(b => b.IsActive && b.Stok > 0).map((b, i) => (
                <div key={i} className="d-flex justify-content-between align-items-center p-2 border-bottom" style={{ cursor: 'pointer' }} onClick={() => addToCart(b)}>
                  <span>{b.NamaBarang} <small className="text-muted">(stok: {b.Stok} {b.Satuan})</small></span>
                  <span className="text-primary">{jenis === 'Kredit' ? formatCurrency(b.HargaKredit) : formatCurrency(b.HargaTunai)}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-7">
            <h6>Keranjang</h6>
            <table className="table table-sm">
              <thead><tr><th>Barang</th><th>Qty</th><th>Harga</th><th>Subtotal</th><th></th></tr></thead>
              <tbody>
                {cart.map((c, i) => {
                  const harga = jenis === 'Kredit' ? parseFloat(c.HargaKredit) : parseFloat(c.HargaTunai)
                  return (
                    <tr key={i}>
                      <td>{c.NamaBarang}</td>
                      <td><input type="number" className="form-control form-control-sm" style={{ width: 70 }} value={c.Qty} onChange={e => updateQty(c.KodeBarang, e.target.value)} min="1" /></td>
                      <td className="text-right">{formatCurrency(harga)}</td>
                      <td className="text-right">{formatCurrency(harga * c.Qty)}</td>
                      <td><button className="btn btn-sm btn-danger" onClick={() => removeFromCart(c.KodeBarang)}><i className="fas fa-times"></i></button></td>
                    </tr>
                  )
                })}
              </tbody>
              <tfoot>
                <tr className="font-weight-bold">
                  <td colSpan="3">Total</td>
                  <td className="text-right">{formatCurrency(totalHarga)}</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
            {cart.length > 0 && (
              <button className="btn btn-success float-right" onClick={handleSubmit} disabled={submitting}>
                {submitting ? <i className="fas fa-spinner fa-spin"></i> : 'Proses Transaksi'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
export default TransaksiBaru
